import { Component } from '@angular/core';

@Component({
  selector: 'app-bulk-vehicle-link',
  templateUrl: './bulk-vehicle-link.component.html',
  styleUrls: ['./bulk-vehicle-link.component.scss']
})
export class BulkVehicleLinkComponent {

}
